<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="d-flex flex-column align-items-start">
        <p class="text-center mb-2 font-size-18 font-weight-bold text-muted">Preview form</p>
        <p class="font-weight-bold mb-0 text-warning">All the required information should be the same as that of matriculation records</p>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-with-addon"
        @click="print"
      >
        <span class="btn-addon">
          <i class="btn-addon-icon fe fe-printer" />
        </span>
        Print
      </button>
    </div>

    <hr />

    <div id="applicationForm" v-if="schoolData">
      <neo-print-wrapper title="Application Form" :footer="false" :schoolData="schoolData">
        <div>
          <div v-if="applicantData.form_status === 3 && ![2, 3].includes(applicantData.status)" class="my-3 d-print-none">
            <a-alert message="Your Application has been submitted! You will be notified via your registered phone number if you are selected for admission!" type="info" show-icon>
            </a-alert>
          </div>
          <div v-if="applicantData.form_status === 3 && applicantData.status === 3" class="my-3 d-print-none">
            <a-alert type="success" show-icon>
              <div class="mb-0" slot="message">
                <p class="mb-0">Your have been admitted successfully! Your student code is <strong>{{applicantData.student.student_code}}</strong></p>
              </div>
              <div class="mb-0" slot="description">
                <p class="font-weight-bold font-italic mb-0">
                  <a href="javascript:0;" @click="handleGotoFeesPage">Click here</a> to go to fees page to view your admission fee payment receipt.
                </p>
              </div>
            </a-alert>
          </div>
          <div v-if="applicantData.status === 2" class="my-3 d-print-none">
            <a-alert type="success" show-icon>
              <template v-slot:message>
                Your Application has been accepted! You can now follow with the admission process!
                <a href="javascript:0;" class="font-weight-bold" @click="handleAdmit">Click Here</a> to complete your admission.
              </template>
            </a-alert>
          </div>

          <!-- <p class="font-weight-bold text-uppercase text-muted mt-3">Personal Data</p> -->
          <div class="row mb-3" v-if="applicantData.form_status === 3 && applicantData.status === 3">
            <div class="col-6 mb-2">
              <p class="font-weight-bold mb-1">Status :
                <span class="font-size-18 font-weight-normal ml-3 text-uppercase">Admitted</span>
              </p>
            </div>
            <div class="col-6 mb-2">
              <p class="font-weight-bold mb-1">Student Code :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student.student_code}}</span>
              </p>
            </div>
          </div>

          <div class="d-print-block d-none">
            <div class="text-center mt-1 py-2">
              <strong class="font-italic text-primary mb-0">All the information are mandatory and should be same as that of matriculation records</strong>
            </div>
            <hr>
          </div>

          <p class="font-weight-bold text-uppercase text-muted mt-3">Application No.:  <span class="text-dark ml-2">{{ applicantData.application_no }}</span></p>
          <hr>
          <p class="font-weight-bold text-uppercase text-muted mt-3">Personal Data</p>
          <div class="row">
            <div class="col-md-2 order-md-2">
              <img v-if="applicantData.photo" :src="applicantData.photo" alt="student photo" class="img-fluid mb-2" width="150">
            </div>
            <div class="col-md-10 order-md-1">
              <div class="row mb-3">
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Student's Full Name :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student_first_name}}</span>
                  </p>
                </div>
                <!-- <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Student's Last Name :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student_last_name}}</span>
                  </p>
                </div> -->
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Date of birth :
                    <span class="font-size-18 font-weight-normal ml-3">{{moment(applicantData.dob).format('DD-MM-YYYY')}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Gender :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.gender}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Nationality :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.nationality}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Aadhaar No :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.aadhaar_no}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Category :
                    <span class="font-size-18 font-weight-normal ml-3">
                      {{find(categoryTypes, {value: applicantData.category}).name}}
                    </span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Language :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.language}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Religion :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.religion}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Tattoo on visible part of body :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.visible_tattoo === 1 ? 'Yes' : 'No'}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Differently Abled Person :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.disabled === 1 ? 'Yes' : 'No'}}</span>
                  </p>
                </div>
                <div class="col-md-6 col-sm-6 mb-2">
                  <p class="font-weight-bold mb-1">Orphan :
                    <span class="font-size-18 font-weight-normal ml-3">{{applicantData.orphan === 1 ? 'Yes' : 'No'}}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3">Transport Details</p>
          <div class="row mb-3">
            <div class="col-md-4 mb-2">
              <p class="font-weight-bold mb-1">Requires transport :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.require_transport === 1 ? 'Yes' : 'No'}}</span>
              </p>
            </div>
            <div class="col-md-8 mb-2">
              <p class="font-weight-bold mb-1">Preferred transport pickup point :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.transport_pickup_point}}</span>
              </p>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3">Contact Details (Present)</p>
          <div class="row mb-3">
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Phone :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_country_code}}{{applicantData.contact_phone}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Email :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_email}}</span>
              </p>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 mb-2">
              <p class="font-weight-bold mb-1">Street Address :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_address}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">City :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_city}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">District :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_district}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Landmark :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_landmark}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">State :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_state}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Pincode :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_pincode}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Country :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_country}}</span>
              </p>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3">Contact Details (Permanent)</p>
          <div class="row mb-3">
            <div class="col-md-12 mb-2">
              <p class="font-weight-bold mb-1">Same as present address :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_same_as_present === 1 ? 'Yes' : 'No'}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Phone :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_country_code}}{{applicantData.permanent_contact_phone}}</span>
              </p>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 mb-2">
              <p class="font-weight-bold mb-1">Street Address :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_address}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">City :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_city}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">District :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_district}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Landmark :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_landmark}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">State :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_state}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Pincode :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_pincode}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Country :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_country}}</span>
              </p>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3">Parent Details</p>
          <p class="font-weight-bold text-muted mt-3">Father's Details</p>
          <div class="row mb-3">
            <div class="col-md-12 mb-2">
              <p class="font-weight-bold mb-1">Father's Full Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.father_suffix}}. {{applicantData.father_first_name}}</span>
              </p>
            </div>
            <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Father's Last Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.father_last_name}}</span>
              </p>
            </div> -->
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Contact Phone :
                <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.father_contact_phone">
                  {{applicantData.father_contact_country_code}}{{applicantData.father_contact_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Whatsapp number :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{applicantData.father_whatsapp_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Father's Qualification :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{find(qualifications, {value: applicantData.father_qualification}).name}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Father's Occupation :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{find(occupations, {value: applicantData.father_occupation}).name}}
                </span>
              </p>
            </div>
          </div>

          <p class="font-weight-bold text-muted mt-3">Mother's Details</p>
          <div class="row mb-3">
            <div class="col-md-12 mb-2">
              <p class="font-weight-bold mb-1">Mother's Full Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.mother_suffix}}. {{applicantData.mother_first_name}}</span>
              </p>
            </div>
            <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Mother's Last Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.mother_last_name}}</span>
              </p>
            </div> -->
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Contact Phone :
                <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.mother_contact_phone">
                  {{applicantData.mother_contact_country_code}}{{applicantData.mother_contact_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Whatsapp number :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{applicantData.mother_whatsapp_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Mother's Qualification :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{find(qualifications, {value: applicantData.mother_qualification}).name}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Mother's Occupation :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{find(occupations, {value: applicantData.mother_occupation}).name}}
                </span>
              </p>
            </div>
          </div>

          <p class="font-weight-bold text-muted mt-3">Guardian's Details</p>
          <div class="row mb-3">
            <div class="col-md-12 mb-2">
              <p class="font-weight-bold mb-1">Guardian's Full Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_first_name ? applicantData.guardian_suffix + '.' : ''}} {{applicantData.guardian_first_name}}</span>
              </p>
            </div>
            <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Guardian's Last Name :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_last_name}}</span>
              </p>
            </div> -->
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Contact Phone :
                <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.guardian_contact_phone">
                  {{applicantData.guardian_contact_country_code}}{{applicantData.guardian_contact_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Whatsapp number :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{applicantData.guardian_whatsapp_phone}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Guardian's Qualification :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{applicantData.guardian_qualification ? find(qualifications, {value: applicantData.guardian_qualification}).name : ''}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
              <p class="font-weight-bold mb-1">Guardian's Occupation :
                <span class="font-size-18 font-weight-normal ml-3">
                  {{applicantData.guardian_occupation ? find(occupations, {value: applicantData.guardian_occupation}).name : ''}}
                </span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Relation with student :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_relation_with_student}}</span>
              </p>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3">Examination Details</p>
          <div class="row mb-3">
            <div class="col-lg-4 col-md-6 col-sm-8 mb-2">
              <p class="font-weight-bold mb-1">Board :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.board}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8 mb-2">
              <p class="font-weight-bold mb-1">Qualifying Exam :
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.qualifying_exam_name}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Board Roll No.:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.board_roll_no}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Result status:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.result_status === 1 ? 'Declared' : 'Awaited' }}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Exam total marks obtained:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.exam_total_score}}</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Year of passing:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.year_of_passing}}</span>
              </p>
            </div>
          </div>

          <div v-if="applicantData.applicant_marks.length">
            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Marks</p>
            <p class="font-weight-bold">Examination score per subject</p>

            <vue-custom-scrollbar class="scroll-area">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">Subject</th>
                    <th scope="col">Score</th>
                    <th scope="col">Full Mark</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="mark in applicantData.applicant_marks" :key="mark.id">
                    <th scope="row">
                        {{ mark.subject }}
                    </th>
                    <td>
                        {{ mark.score }}
                    </td>
                    <td>
                        {{ mark.full_mark }}
                    </td>
                    <td>
                        {{ mark.status === 1 ? 'Pass' : 'Fail' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </vue-custom-scrollbar>
          </div>

          <hr />
          <div class="row mt-3">
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">PC Score:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.pc_score}}%</span>
              </p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Grade:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.grade}}</span>
              </p>
            </div>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Extra curricular</p>
          <p class="font-weight-bold">Awards / Achievements (if any / latest two / most significant two)</p>

          <div>
            <vue-custom-scrollbar class="scroll-area">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Received when</th>
                    <th scope="col">Received for</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in 2" :key="index">
                    <th scope="row" style="height:2rem;">
                        {{ applicantData['ec' + index + '_name'] }}
                    </th>
                    <td style="height:2rem;">
                        {{ applicantData['ec' + index + '_when'] }}
                    </td>
                    <td style="height:2rem;">
                        {{ applicantData['ec' + index + '_for'] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </vue-custom-scrollbar>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase mt-3 mb-1">Last school details</p>
          <div class="row mt-3">
            <div class="col-lg-6 col-md-8 col-sm-12 mb-2">
              <p class="font-weight-bold mb-1">School name:
                <span class="font-size-18 font-weight-normal ml-3">{{applicantData.last_school_name}}</span>
              </p>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">School Type:
                <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.last_school_type}}</span>
              </p>
            </div> -->
            <div class="col-lg-3 col-md-6 col-sm-6 mb-2">
              <p class="font-weight-bold mb-1">Medium of study:
                <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.last_school_medium}}</span>
              </p>
            </div>
          </div>

          <div v-if="applicantData.subject_group">
            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Subject grouping opted for admission <span class="text-warning">(Subject Once Opted cannot be changed)</span></p>
            <div class="row mt-3">
              <div class="col-12 mb-3">
                <p class="font-weight-bold mb-1">
                  <span
                    v-for="(subject, index) in applicantData.subject_group.subjects" :key="subject.id"
                    class="font-size-18 font-weight-normal"
                  >
                    {{getSubjectName(subject, index, applicantData.subject_group.subjects.length)}}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Uniform Details</p>
            <div v-if="applicantData.uniforms.length">
              <vue-custom-scrollbar class="scroll-area">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Uniform</th>
                      <th scope="col">Type</th>
                      <th scope="col">Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="uniform in applicantData.uniforms" :key="uniform.id">
                      <th scope="row">
                          {{ uniform.uniform_type.name }}
                      </th>
                      <td>
                          {{ uniform.uniform_type_variant ? uniform.uniform_type_variant.name : '--' }}
                      </td>
                      <td>
                          {{ uniform.uniform_size.name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </vue-custom-scrollbar>
            </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Sports</p>
          <div class="mb-2">
            <p class="font-weight-bold mb-1">Is sports person:
              <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.sports_person ? 'Yes' : 'No'}}</span>
            </p>
          </div>

          <hr />
          <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Uploaded documents</p>
          <div class="row my-3">
            <!-- <div class="col-md-3">
              <p class="font-weight-bold mb-1">Student Photo:</p>
              <img v-if="applicantData.photo" :src="applicantData.photo" alt="student photo" class="img-fluid mb-2" width="150">
            </div> -->
            <div class="col-md-3">
              <p class="font-weight-bold mb-1">Marksheet:</p>
              <div v-if="this.applicantData.document">
                <a :href="this.applicantData.document" class="btn btn-sm btn-dark d-print-none" target="_blank">View Marksheet</a>
                <p class="d-none d-print-block">Uploaded</p>
              </div>
            </div>
            <div class="col-md-3">
              <p class="font-weight-bold mb-1">Admit card/Student ID Card:</p>
              <div v-if="this.applicantData.admit_card">
                <a :href="this.applicantData.admit_card" class="btn btn-sm btn-dark d-print-none" target="_blank">View Admit card</a>
                <p class="d-none d-print-block">Uploaded</p>
              </div>
            </div>
            <div class="col-md-3" v-if="this.applicantData.sports_person">
              <p class="font-weight-bold mb-1">Sports Certificate:</p>
              <div v-if="this.applicantData.sport_cert">
                <a :href="this.applicantData.sport_cert" class="btn btn-sm btn-dark d-print-none" target="_blank">View Sports Cert.</a>
                <p class="d-none d-print-block">Uploaded</p>
              </div>
            </div>
          </div>

          <div class="py-3 text-center bg-light d-print-none" v-if="applicantData.form_status !== 3">
            <p class="font-weight-bold mb-1">Acknowledgement</p>
            <a-checkbox v-model="acknowledged">
              <span class="mb-0 font-weight-bold font-italic text-danger">
                {{ declaration }}
              </span>
            </a-checkbox>
          </div>

          <div class="d-none d-print-block text-center mt-3">
            <span class="mb-0 font-weight-bold font-italic text-dark">
              {{ declaration }}
            </span>
          </div>

          <div class="d-flex justify-content-between my-4">
            <div class="col-md-4 text-left">
              <img v-if="applicantData.parent_signature" :src="applicantData.parent_signature" alt="parent /guardian signature" class="img-fluid mb-2" width="200">
              <p class="font-weight-bold mt-2">Parent/Guardian Signature:</p>
            </div>
            <div class="col-md-4 text-right">
              <img v-if="applicantData.student_signature" :src="applicantData.student_signature" alt="student signature" class="img-fluid mb-2" width="200">
              <p class="font-weight-bold mt-2">Student's Signature:</p>
            </div>
          </div>

          <hr v-if="applicantData.form_status === 3 && applicationFormData.payment_mode !== 1"/>

          <div class="py-3 text-center" v-if="applicantData.form_status === 3 && applicationFormData.payment_mode !== 1">
            <p class="mb-0 text-dark font-size-18">Application Fee:
              <span class="font-weight-bold mx-2">₹{{ applicationFormData.application_fee }}</span>
              to be paid {{ applicationFormData.payment_mode === 1 ? 'Online' : 'Offline' }}
            </p>
          </div>
          <hr />

        </div>
      </neo-print-wrapper>

      <div v-if="applicantData.status === 2">
        <div v-if="applicationFormData.online_admission && applicationFormData.admission_fee.fee_amount">
           <a-alert type="success">
             <p slot="message" class="text-center font-weight-bold mb-0">
              Admission Fee:  ₹{{applicationFormData.admission_fee.fee_amount}}
            </p>
           </a-alert>
         <hr>
        </div>
      </div>

      <div v-if="applicantData.form_status === 3 && applicationFormData.payment_mode === 1">
        <div class="text-center">
          <button
            type="button"
            class="btn btn-light btn-with-addon"
            @click="printReceipt"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-printer" />
            </span>
            Print Application Fee Receipt
          </button>
        </div>
        <div class="d-none" id="applicationReceipt">
          <neo-print-wrapper title="Application Form Receipt" :footer="false" :schoolData="schoolData">
            <div class="row">
              <div class="col-md-6 col-lg-6 mb-2">
                <p class="font-weight-bold mb-1">Application id :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.application_id}}</span>
                </p>
              </div>
              <div class="col-md-6 col-lg-6 mb-2">
                <p class="font-weight-bold mb-1">Application no. :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.application_no}}</span>
                </p>
              </div>
            </div>
            <div class="row mb-3" v-for="transaction in applicantData.applicant_transactions" :key="transaction.id">
              <div class="col-md-6 col-lg-6 mb-2">
                <p class="font-weight-bold mb-1">Reference Number :
                  <span class="font-size-18 font-weight-normal ml-3">{{transaction.order_id}}</span>
                </p>
              </div>
              <div class="col-md-6 col-lg-4 mb-2">
                <p class="font-weight-bold mb-1">Amount :
                  <span class="font-size-18 font-weight-normal ml-3">₹{{transaction.order_amount}}</span>
                </p>
              </div>
              <div class="col-md-6 col-lg-4 mb-2">
                <p class="font-weight-bold mb-1">Reference id :
                  <span class="font-size-18 font-weight-normal ml-3">{{transaction.reference_id}}</span>
                </p>
              </div>
              <div class="col-md-6 col-lg-4 mb-2">
                <p class="font-weight-bold mb-1">Paid on :
                  <span class="font-size-18 font-weight-normal ml-3">{{moment(transaction.tx_time).format('DD-MM-YYYY')}}</span>
                </p>
              </div>
            </div>
          </neo-print-wrapper>
        </div>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-6">
        <a-button
          type="primary"
          size="large"
          :class="['text-center btn font-weight-bold font-size-18 mt-2', applicantData.form_status > 1 ? 'btn-default' : 'btn-dark']"
          :disabled="applicantData.form_status > 1"
          v-on:click.prevent="handlePrevious"
        >Previous</a-button>
      </div>
      <div class="col-md-6 text-md-right">
        <a-button
          v-if="applicantData.status === 2 && applicationFormData.online_admission === 1"
          type="primary"
          size="large"
          :class="['text-center btn btn-success font-weight-bold font-size-18 mt-2']"
          @click="handleAdmit"
        >Pay & Admit
        </a-button>
        <a-button
          v-if="applicantData.status === 2 && applicationFormData.online_admission !== 1"
          type="primary"
          size="large"
          :class="['text-center btn btn-success font-weight-bold font-size-18 mt-2 disabled']"
        >Visit office for admission
        </a-button>
        <a-button
          v-if="applicantData.status !== 2"
          type="primary"
          size="large"
          :class="['text-center btn font-weight-bold font-size-18 mt-2', applicantData.form_status === 3 ? 'btn-default': 'btn-primary']"
          :disabled="applicantData.form_status === 3 ? true : false"
          @click="handleSubmit"
        >{{ applicationFormData.payment_mode === 1 ? 'Pay & Submit' : 'Submit' }}
        </a-button>
      </div>
    </div>

    <div class="d-none">
      <form id="redirectForm"
        method="post"
        :action="paymentUrl"
      >
        <input type="hidden" name="appId" :value="paymentData.appId"/>
        <input type="hidden" name="orderId" :value="paymentData.orderId"/>
        <input type="hidden" name="orderAmount" :value="paymentData.orderAmount"/>
        <input type="hidden" name="orderCurrency" :value="paymentData.orderCurrency"/>
        <input type="hidden" name="orderNote" :value="paymentData.orderNote"/>
        <input type="hidden" name="customerName" :value="paymentData.customerName"/>
        <input type="hidden" name="customerEmail" :value="paymentData.customerEmail"/>
        <input type="hidden" name="customerPhone" :value="paymentData.customerPhone"/>
        <input type="hidden" name="returnUrl" :value="paymentData.returnUrl"/>
        <input type="hidden" name="notifyUrl" :value="paymentData.notifyUrl"/>
        <input type="hidden" name="signature" :value="paymentData.signature"/>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'
import { mapState } from 'vuex'

import NeoPrintWrapper from '@/components/layout/Print/Default'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import { countryCodes, genderTypes, categoryTypes, qualifications, occupations, nameSuffixes } from '@/services/globaldata'

const subdomain = window.location.host.split('.')[0]

export default {
  name: 'FormStepFive',
  props: ['applicantData', 'applicationFormData'],
  components: {
    vueCustomScrollbar,
    NeoPrintWrapper,
  },
  mounted() {
    this.getSchoolData()
    this.paymentUrl = process.env.VUE_APP_CASHFREE_URL
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      schoolData: null,
      acknowledged: false,
      countryCodes,
      genderTypes,
      categoryTypes,
      qualifications,
      occupations,
      nameSuffixes,
      paymentData: {},
      paymentUrl: '',
      declaration: ' I, hereby solemnly declare that all statements made in the above application are true and correct to the best of my knowledge and belief. Also, I will abide by the rules and regulations of the school.',
    }
  },
  computed: {
    ...mapState(['applicant']),
  },
  methods: {
    moment,
    find,
    handlePrevious() {
      this.$emit('previous', 4)
    },
    getSubjectName(subject, index, length) {
      if (index < length - 1) {
        return subject.name + ', '
      }
      return subject.name
    },
    getSchoolData: function() {
      this.loading = true
      this.$http.get(`/api/school/subdomain/${subdomain}`)
        .then(({ data }) => {
          this.loading = false
          this.schoolData = data.data
        })
    },
    print() {
      this.$htmlToPaper('applicationForm')
    },
    printReceipt() {
      this.$htmlToPaper('applicationReceipt')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.loading = true
      if (this.acknowledged) {
        this.$confirm({
          title: `Are you sure?`,
          content: `Click on the OK submit your application form!`,
          onOk: () => {
            this.$http
              .get(`/api/application-form/payment_details/${this.applicantData.id}`, {
                params: {
                  token: this.applicant.app_form_token,
                  form_id: this.applicationFormData.id,
                },
              })
              .then(({ data }) => {
                if (data.type === 'error') {
                  this.$applicantAuth.logout()
                } else {
                  if (data.data.payment_mode !== 1) {
                    this.loading = false

                    this.handleFormSubmission()
                  } else {
                    this.handleApplicationFeePayment(data.data)
                  }
                }
              })
              .catch(error => {
                this.loading = false
                this.$neoNotify.error(error)
              })
          },
          onCancel: () => {
            this.loading = false
          },
        })
      } else {
        this.$message.error('You need to check the Acknowledgement check box!')
      }
    },

    handleFormSubmission() {
      this.loading = true
      this.$http
        .patch(`/api/application-form/submit/${this.applicant.applicant_id}`, {
          token: this.applicant.app_form_token,
        })
        .then(({ data }) => {
          if (data.type === 'error') {
            this.$applicantAuth.logout()
          } else {
            this.$emit('saved')
            this.loading = false

            this.$notification['success']({
              message: 'Successfully submitted!',
              description: `Your application has been submitted successfully!`,
            })
          }
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleApplicationFeePayment(paymentData) {
      this.$http
        .get(`/api/application-form/payment_details/${this.applicantData.id}`, {
          params: {
            token: this.applicant.app_form_token,
            form_id: this.applicationFormData.id,
            make_payment_data: true,
          },
        })
        .then(({ data }) => {
          if (data.type === 'error') {
            this.$applicantAuth.logout()
          } else {
            this.loading = false
            const paymentDetails = data.data

            let paymentData = {
              appId: paymentDetails.app_id,
              orderId: paymentDetails.order_id,
              orderAmount: paymentDetails.fee,
              customerName: paymentDetails.name,
              customerPhone: paymentDetails.phone,
              customerEmail: paymentDetails.email,
              notifyUrl: paymentDetails.notify_url,
              returnUrl: paymentDetails.return_url,
              orderNote: paymentDetails.order_note,
              // pc: '',
              orderCurrency: paymentDetails.currency,
              signature: paymentDetails.signature,
            }

            this.paymentData = paymentData

            this.$nextTick(() => {
              document.getElementById('redirectForm').submit()
            })
          }
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleAdmit(e) {
      e.preventDefault()
      this.loading = true
      this.$confirm({
        title: `Are you sure?`,
        content: `Click OK to pay ₹${this.applicationFormData.admission_fee.fee_amount} and proceed to admission.`,
        onOk: () => {
          console.log('Admit')
          this.$http
            .post(`/api/process-admission-fee-payment/${this.applicant.applicant_id}`, {
              token: this.applicant.app_form_token,
            })
            .then(({ data }) => {
              if (data.type === 'error') {
                this.$applicantAuth.logout()
              } else {
                this.loading = false

                const paymentDetails = data.data

                let paymentData = {
                  appId: paymentDetails.app_id,
                  orderId: paymentDetails.order_id,
                  orderAmount: paymentDetails.order_amount,
                  customerName: paymentDetails.name,
                  customerPhone: paymentDetails.phone,
                  customerEmail: paymentDetails.email,
                  notifyUrl: paymentDetails.notify_url,
                  returnUrl: paymentDetails.return_url,
                  orderNote: paymentDetails.order_note,
                  // pc: '',
                  orderCurrency: paymentDetails.currency,
                  signature: paymentDetails.signature,
                }

                console.log(paymentData)

                this.paymentData = paymentData

                this.$nextTick(() => {
                  document.getElementById('redirectForm').submit()
                })
              }
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },

    handleGotoFeesPage() {
      this.$router.push({ name: 'publicpayfees', query: { sc: this.applicantData.student.student_code } })
    },
  },
}
</script>
